<template>
  <div>
    <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
  </div>
</template>

<script>
import { StreamBarcodeReader } from 'vue-barcode-reader';

export default {
  methods: {
    onDecode(result) {
      console.log('Código escaneado:', result);
    },
    onLoaded() {
      console.log('Lector de códigos de barras cargado');
    }
  }
};
</script>
